export const getFilteredTransactions = ({
    transactions,
    filter,
    selectedScrip,
    selectedPartner
}) => {
    return transactions
        .filter((transaction) =>
            (filter === "all" || transaction.transactionType === filter) &&
            (selectedScrip === "all" || transaction.scrip === selectedScrip) &&
            (selectedPartner.id === "all" || transaction.partnerId === selectedPartner.id)
        )
        .sort((a, b) => new Date(a.date) - new Date(b.date));
};

export const getUniqueScrips = (transactions, selectedPartner) => {
    return [
        ...new Set(
            transactions
                .filter(
                    (tx) =>
                        selectedPartner.id === "all" ||
                        tx.partnerId === selectedPartner.id
                )
                .map((tx) => tx.scrip)
        ),
    ].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
};

export const getUniquePartners = (transactions) => {
    const map = new Map();

    transactions.forEach((tx) => {
        if (!map.has(tx.partnerId)) {
            map.set(tx.partnerId, {
                id: tx.partnerId,
                name: tx.partner
            });
        }
    });

    return Array.from(map.values()).sort((a, b) =>
        a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
};